import { Box, Card, CardContent, Container, Grid, Icon } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import CoreH4 from "../../core/dataDisplay/CoreH4";
import { theme } from "../../config/theme";
import CoreTypographyCaption from "../../core/dataDisplay/CoreTypographyCaption";
import CoreTypographyBody1 from "../../core/dataDisplay/CoreTypographyBody1";
import { backendUrl } from "../../config/api";
import { setNextUrl } from "../../store/actions/routeActions";

export default function AuthContainer(props) {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const onHome = () => {
    navigate("/");
    dispatch(setNextUrl("/"));
  };

  return (
    <Box
      style={{
        height: "100vh",
        width: "100vw",
        marginTop: "-16px",
        marginLeft: "24px",
      }}
    >
      <Box
        style={{ height: "10%", width: "100%", paddingLeft: 32 }}
        onClick={onHome}
      >
        <img
          style={{ alignSelf: "center" }}
          height="100%"
          // width="10px"
          src="/docxplor-logo-full.webp"
          alt="Logo of docxplor"
        />
      </Box>
      <Container style={{ height: "82%", width: "100%" }}>
        <Grid container spacing={2} style={{ height: "100%" }}>
          <Grid item xs={0} md={4}></Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <Card style={{ minWidth: "90%", maxWidth: "90%" }}>
              <CardContent style={{ padding: 0 }}>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: "16px",
                    minHeight: "330px",
                  }}
                >
                  {/* {props.showHeading && <CoreH4>DocXplor</CoreH4>} */}
                  {props.children}
                </Box>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={0} md={2}></Grid>
        </Grid>
      </Container>
      <Box
        style={{
          height: "10%",
          width: "100%",
          backgroundColor: theme.palette.background.default,
        }}
      >
        <Grid container style={{ height: "100%" }}>
          <Grid
            xs={6}
            style={{ display: "flex", alignItems: "center", paddingLeft: 32 }}
          >
            <a
              style={{ textDecoration: "none" }}
              href={
                "https://play.google.com/store/apps/details?id=com.docxplor&pcampaignid=web_share"
              }
            >
              <img
                width="150px"
                src="/playstore-logo.svg"
                alt="Logo of google playstore"
              />
            </a>
          </Grid>
          <Grid
            xs={6}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              height: "100%",
            }}
          >
            <a
              style={{ textDecoration: "none" }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.vixplor.com/privacy-policy"
            >
              <CoreTypographyBody1>Privacy</CoreTypographyBody1>
            </a>
            <a
              style={{
                textDecoration: "none",
                marginLeft: 32,
                marginRight: 32,
              }}
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.vixplor.com/terms-conditions"
            >
              <CoreTypographyBody1>Terms</CoreTypographyBody1>
            </a>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}
